<div class="security-container">
  <div class="row">
    <div class="col-12 mb-3 mt-1">
      <div class="container-title">Security</div>
    </div>
    <div class="col-12">
      <p class="container-desc">
        Protect your account with Multi-factor Authentication works by requiring additional factors
        during the login process to prevent unauthorized access.
      </p>
    </div>
  </div>
  <div class="row d-none">
    <div class="col-md-12">
      <div class="mfa-notice-row">
        <span
          ><svg
            width="26"
            height="24"
            viewBox="0 0 26 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M25.5128 21.0248L14.6702 1.06155C13.9017 -0.35385 11.8544 -0.35385 11.0853 1.06155L0.243298 21.0248C0.0764335 21.332 -0.00722486 21.6769 0.000489037 22.0258C0.00820293 22.3747 0.107026 22.7157 0.287311 23.0154C0.467597 23.3151 0.723185 23.5634 1.02913 23.736C1.33507 23.9085 1.68092 23.9995 2.0329 24H23.72C24.0723 24 24.4185 23.9095 24.7249 23.7371C25.0313 23.5648 25.2873 23.3166 25.468 23.0168C25.6486 22.7169 25.7477 22.3758 25.7556 22.0266C25.7635 21.6775 25.6798 21.3323 25.5128 21.0248ZM12.878 20.9093C12.6264 20.9093 12.3804 20.8353 12.1712 20.6967C11.9619 20.5581 11.7988 20.3611 11.7025 20.1306C11.6062 19.9001 11.581 19.6464 11.6301 19.4017C11.6792 19.157 11.8004 18.9322 11.9783 18.7558C12.1563 18.5794 12.383 18.4592 12.6298 18.4106C12.8766 18.3619 13.1325 18.3869 13.365 18.4824C13.5975 18.5778 13.7962 18.7395 13.936 18.947C14.0758 19.1544 14.1504 19.3983 14.1504 19.6478C14.1504 19.9824 14.0164 20.3033 13.7778 20.5398C13.5391 20.7764 13.2155 20.9093 12.878 20.9093ZM14.2599 8.22181L13.8947 15.917C13.8947 16.1846 13.7874 16.4413 13.5965 16.6306C13.4057 16.8198 13.1467 16.9261 12.8768 16.9261C12.6068 16.9261 12.3479 16.8198 12.157 16.6306C11.9661 16.4413 11.8589 16.1846 11.8589 15.917L11.4937 8.22497C11.4855 8.04116 11.5147 7.8576 11.5796 7.68522C11.6444 7.51284 11.7437 7.35517 11.8713 7.22162C11.9989 7.08807 12.1524 6.98136 12.3225 6.90786C12.4926 6.83436 12.6759 6.79557 12.8615 6.7938H12.8749C13.0617 6.7937 13.2466 6.83114 13.4184 6.90384C13.5903 6.97655 13.7455 7.08301 13.8747 7.21682C14.0039 7.35063 14.1044 7.509 14.1701 7.68238C14.2359 7.85576 14.2656 8.04055 14.2573 8.2256L14.2599 8.22181Z"
              fill="#FFAD0D"
            /></svg
        ></span>
        <span>
          Notice: Add Multi-Factor Authentication to improve the security of your account.</span
        >
        <span>
          <ces-button
            size="small"
            icon="icon-close"
            [ghost]="true"
            [onlyIcon]="true"
            [ghostType]="'secondary'"
            btnClass="ces-icons set-alert-modal-header-close"
            iconPosition="left"
          ></ces-button
        ></span>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mfa-container">
      <div
        class="mfa-factor-container"
        *ngIf="!loader"
      >
        <div class="row">
          <div class="col-md-12">
            <span class="mfa-title">Multi-Factor Authentication (MFA)</span>
          </div>
          <div class="col-md-12">
            <p class="mfa-desc">
              Secure your account by Multi-factor Authentication works by requiring additional
              factors during the login process to prevent unauthorized access.
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="mfa-card">
              <div class="mfa-icon">
                <i class="icon icon-globe app-icon"></i>
              </div>
              <div class="mfa-factor-title-desc">
                <div class="mfa-factor-title">One Time Password</div>
                <div class="mfa-factor-desc">
                  Provide a one-time password using Google Authenticator or similar.
                </div>
              </div>
              <div class="mfa-button">
                <ces-button
                  *ngIf="!isOtpSet && !loader"
                  label="SET UP"
                  status="primary"
                  size="small"
                  (click)="setupGoogleAuthenticator('otp')"
                >
                </ces-button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mfa-card">
              <div class="mfa-icon">
                <i class="icon icon-bell app-icon"></i>
              </div>
              <div class="mfa-factor-title-desc">
                <div class="mfa-factor-title">Push Notification</div>
                <div class="mfa-factor-desc">
                  Provide a push notification using the Auth0 Guardian app or SDK.
                </div>
              </div>
              <div class="mfa-button">
                <ces-button
                  *ngIf="!isGuardianSet && !loader"
                  label="SET UP"
                  status="primary"
                  size="small"
                  (click)="setupGoogleAuthenticator('push-notification')"
                >
                </ces-button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mfa-card">
              <div class="mfa-icon">
                <i class="icon icon-recording app-icon"></i>
              </div>
              <div class="mfa-factor-title-desc">
                <div class="mfa-factor-title">Phone Message</div>
                <div class="mfa-factor-desc">
                  Users will receive a text message containing a verification code.
                </div>
              </div>
              <div class="mfa-button">
                <ces-button
                  *ngIf="!isPhoneSet && !loader"
                  label="SET UP"
                  status="primary"
                  size="small"
                  (click)="setupGoogleAuthenticator('sms')"
                >
                </ces-button>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mfa-card">
              <div class="mfa-icon">
                <i class="icon icon-envelope app-icon"></i>
              </div>
              <div class="mfa-factor-title-desc">
                <div class="mfa-factor-title">Email</div>
                <div class="mfa-factor-desc">
                  Users will receive an email message containing a verification code.
                </div>
              </div>
              <div class="mfa-button">
                <ces-button
                  *ngIf="!isEmailSet && !loader"
                  label="SET UP"
                  status="primary"
                  size="small"
                  (click)="setupGoogleAuthenticator('email')"
                >
                </ces-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="widget-loader"
        *ngIf="loader"
      >
        <ces-loaders
          type="spinner"
          size="medium"
          textPosition="center"
        ></ces-loaders>
      </div>
    </div>
  </div>
  <div #container></div>
</div>
